/**
 * Session-end summary emitter.
 *
 * On window unload, walks `getAllStats()` and emits one
 * `app:crash-session-summary` event per signature with count > 1.
 *
 * This lets the backend see the true volume of looping crashes in a session
 * without being flooded by duplicate full `app:crash-occurred` reports.
 */
import { getAllStats } from './crashDedupService';
import type { CrashReportMode } from '../types/crashTypes';

type TrackFn = (
  eventName: string,
  data: Record<string, string | number | boolean>,
) => void;

export const emitSessionSummary = (
  track: TrackFn,
  reportMode: CrashReportMode,
): void => {
  for (const { signature, count, stance } of getAllStats()) {
    if (count <= 1) continue;
    const [category, ...messageParts] = signature.split('::');
    const message = messageParts.join('::');
    track('app:crash-session-summary', {
      category,
      messagePrefix: message.slice(0, 120),
      totalCount: count,
      stance,
      reportMode,
    });
  }
};
